module.exports = __webpack_public_path__ + "static/media/splashMusic.ce54a3a2.mp3";